import StatList from "./StatList";

export default StatList